import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { ProductService } from "~/features/addToCart/api/ProductService";
import { isPackageRestrictionEnabled } from "~/features/PackageRestriction/utils/isPackageRestrictionEnabled";
import { selectPackageBasedOnQuery } from "~/utils/cartHelper";
import { addMessage } from "~/features/toasts/redux/actions";

export const useCalculateRestrictedCode = (query: string, productCode: string) => {
  const productDescriptor = ProductService.useProductDescriptor({
    productCode,
    priceReference: "",
    options: { fetch: true },
  });

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const restrictedCode = useMemo(() => {
    if (!isPackageRestrictionEnabled()) {
      return null;
    }

    if (!productDescriptor.availability) {
      return null;
    }
    const restrictedPackage = selectPackageBasedOnQuery(query)(productDescriptor.availability, productDescriptor.base);
    if (!restrictedPackage) {
      if (query.replace(/-/g, "").length === 15) {
        dispatch(addMessage("info", t("restrictedPackaging.notFound")));
      }
      return null;
    }
    return restrictedPackage.packCode;
  }, [productDescriptor.availability, productDescriptor.base, query]);

  return restrictedCode;
};
